export const ERROR_MESSAGE = "Something went wrong.";
